import CollapseSubcategoryView from './CollapseSubcategoryView'

export default CollapseSubcategoryView
